export class BaseHolding {
	public description?: string;
	public assetClass?: string;
	public identifier?: string;
	public identifierType?: string;
	public commonIdentifier?: string;
	public commonIdentifierType?: string;
	public cusip?: string;
	public type?: string;
	public subType?: string;
	public ticker?: string;
	public isin?: string;
	public uniqueId?: string;
	public weight?: number;
	public value?: number;
	public mstarCategory?: string;
	public originPlatform?: {};
	public otherIdentifiers?: any[];
	public positionType?: string;
	public substitutedFrom?: SubstitutedFrom;
	public dateLastModified?: number;
	public morningstarCategory?: string;
	public assetType?: string;
	public legalType?: string;
	public morningstarFundId?: string;
	public morningstarSecId?: string;
	public globalId?: string;
	public aladdinId?: string;
	public assetId?: string;
	public market?: string;
	public currency?: string;
	public identifiersMap?: Map<string, string>;
	public selected?: boolean;
	public peOrder?: number;
	public clientId?: string;
	public error?: any;
	public aladdinPortfolioCode?: string;
	public tpmId?: string;
	public marketValue?: number;
}

/**
 * To be used for showing inline alerts in overview page for partner portfolios
 * 
 * @invalidSecurities used to show Cash substitution alerts (When user replaces invalid security with Cash)
 * @assetClass used to show asset class substitution alerts
 * 
 * @export
 * @class SubstitutedFrom
 */
export interface SubstitutedFrom {
	invalidSecurities: Array<BaseHolding>;
	assetClass: Array<BaseHolding>;
}
